import { FunctionComponent } from 'react';
import {
  Box,
  Typography,
  ListItemText,
  ListItemAvatar,
  Avatar,
  ListItemButton,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import dummyImage from 'assets/images/dummyImage.png';
import { timeAgo } from 'utils/utility';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';
import {
  NOTIFICATION_TYPES,
  APPROVAL_REQUEST_STATUS,
} from 'constant';
import { useUpdateUnreadNotificationMutation } from 'api/notificationApi';

import { useNotifications } from './useNotifications';
import { NotificationHeader } from './style';

const NotificationItem: FunctionComponent<any> = ({
  notification,
  handleClose,
}) => {
  const navigate = useNavigate();

  const {
    notificationText,
    redirectRoute,
    notificationType,
    isSenderReceiver,
    displayName,
    status,
    shouldRedirectToToastmasterWebsite,
  } = useNotifications(notification);
  const [updateUnReadNotification] = useUpdateUnreadNotificationMutation();

  const handleClick = () => {
    updateUnReadNotification(notification.slug);
    handleClose();

    if (status === APPROVAL_REQUEST_STATUS.Reversed) {
      toast.info(
        `The request has become obsolete. The learner's progress may have been reversed. For further information, please reach out to our support team.`,
      );

      return;
    }

    const toastmastersWebsiteUrl = () => getConfig().TOASTMASTERS_WEBSITE_URL;
    if (shouldRedirectToToastmasterWebsite) {
      window.location.assign(`${toastmastersWebsiteUrl()}start-pathways/select-your-preference`);

      return;
    }

    if (!redirectRoute) {
      return;
    }

    if (
      NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment === notificationType ||
      NOTIFICATION_TYPES.clubCoachModuleEnrollment === notificationType ||
      NOTIFICATION_TYPES.courseInactivity === notificationType ||
      NOTIFICATION_TYPES.courseEnrollment === notificationType ||
      (NOTIFICATION_TYPES.completionReview === notificationType && status !== APPROVAL_REQUEST_STATUS.Denied) ||
      (notificationType === NOTIFICATION_TYPES.completionReviewNotifyBCM &&
        isSenderReceiver) ||
      NOTIFICATION_TYPES.speechcrafterCertificate === notificationType
    ) {
      window.location.assign(redirectRoute);
      return;
    }

    navigate(redirectRoute);
  };

  const courseImageNotificationTypes = [NOTIFICATION_TYPES.pathwaysMentorProgramEnrollment,
    NOTIFICATION_TYPES.courseInactivity, NOTIFICATION_TYPES.completionRequestSecondReminder, NOTIFICATION_TYPES.completionRequestFirstReminder, NOTIFICATION_TYPES.preCourseEnrollment,
    NOTIFICATION_TYPES.completionReview, NOTIFICATION_TYPES.completionRequest, NOTIFICATION_TYPES.courseEnrollment, NOTIFICATION_TYPES.completionReviewNotifyBCM];

  const lmsBaseUrl = () => getConfig().LMS_BASE_URL;
  return (
    <ListItemButton onClick={handleClick}>
      <ListItemAvatar>
        <Avatar
          aria-hidden="true"
          role="img"
          alt={displayName ? displayName : notification?.sender?.username}
          src={
            courseImageNotificationTypes.includes(notificationType)
              ? lmsBaseUrl() + notification?.target?.courseImage
              : notification?.sender?.memberPhotoUrl
          }
          onError={({ currentTarget }: any) => {
            currentTarget.onerror = null;
            currentTarget.src = dummyImage;
          }}
        />
      </ListItemAvatar>
      <ListItemText
        primary={
          <>
            <NotificationHeader>
              <Typography
                variant='h4'
                component='span'
                className='fw-700 text-capitalize'
              >
                {displayName}
              </Typography>
              <Typography
                variant='h4'
                component='span'
                className='fw-700 notify-timestamp'
                aria-hidden="true"
              >
                {timeAgo(notification.timestamp)}
              </Typography>
            </NotificationHeader>
            <Box sx={{ mr: 5 }}>
              <div dangerouslySetInnerHTML={{ __html: notificationText }}></div>
            </Box>
          </>
        }
      />
    </ListItemButton>
  );
};

export default NotificationItem;
